<template>
    <div id="sinester-admin">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">

            <!--  SUBIR TICKETS PAGO DE FACTURA -->
            <invoice-ticket
                :type_model="model_type_row"
                :invoice_array="savedSelectedRows"
                :supplier_id_row="supplier_id_row"
                :total_invoice_row="total_invoice_row"
                v-if="modalTicket"/>

            <!--  SUBIR COMPLEMENTO DE FACTURA-->
            <complement-invoice
                :type_model="computedModelTypeRow"
                :invoice_array="savedSelectedRows"
                :supplier_id="supplier_id_row"
                :role_id="supplier_id_row"
                v-if="complementInvoice"/>

        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-md-3 ">
                            <b-pagination
                                :disabled="(specialist_id !== null)"
                                pills align="fill"
                                :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12 col-md-1 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-2 offset-md-4">
                            <div class="filter_content mt-3 float-end">
                                <a class="filterIcon" @click="toggleOpen" :class="{ open: isOpen }" href="#">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </a>
                            </div>
                            <div id="filter_content" class="position-absolute view" v-show="isOpen">
                                <div class="row">
                                    <div class="col-12 col-md-12 cont_select">
                                        <select data-select="on" v-model="prov_role_id" name="ciudad" id="ciudad"
                                                v-on:change="selectCompanyByRoleProvider($event)" class="required">
                                            <option :value="0">Tipo de Proveedor*</option>
                                            <option v-for="prov in providers" :value="prov.id" :key="prov.id">
                                                {{ prov.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-12 col-md-12 mt-4 cont_select">
                                        <select data-select="on" v-model="specialist_id" name="provider" id="provider"
                                                v-on:change="filterBySpecialist()" class="required">
                                            <option :value="null">Proveedor*</option>
                                            <option v-for="lprov in list_providers" :value="lprov.id" :key="lprov.id">
                                                {{ lprov.genericName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-12 col-md-12 mt-4 cont_select">
                                        <select id="sinister_status_paid" class="float" v-model="params.status"
                                                v-on:change="filterStatusSinister()">
                                            <option :value="null">Todas</option>
                                            <option :value="0">Siniestros sin pagar C/F</option>
                                            <option :value="1">Siniestros Pagados</option>
                                            <option :value="2">Siniestros S/F</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-2">
                            <select v-if="savedSelectedRows.length>0" name="" id="" @change="updateAction($event)">
                                <option value="none">Selecciona una acción</option>
                                <option value="1">Subir Pagos</option>
                                <option value="2">Subir Complemento</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table sticky-header="100vh" stacked="md" id="my-table" striped hover :fields="fields"
                                 :busy="isBusy" :items="pagination.data" :filter="filter" :select-mode="selectMode"
                                 selectable @row-selected="onRowSelected" no-select-on-click ref="selectableTable">
                            <template #head(acciones)="{item}">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #head(subir)="{item}">
                                <i class="fa-solid fa-upload"></i>
                            </template>
                            <template #cell(subir)="{ rowSelected, index, item }" v-if="specialist_id!==null">
                                <button class="badge rounded-pill border-0"
                                        :class="rowSelected?'text-bg-green':'text-bg-orange'"
                                        v-if="item.payment_complement_id==null"
                                        @click="clickRow(index, item, rowSelected)">
                                    <i class="fa-solid fa-angles-up"></i>
                                </button>
                            </template>
                            <template #cell(id)="{item}">
                                <span>{{ item.id }}</span>
                            </template>
                            <template #cell(proveedor)="{item}">
                                <span>{{ item.name }}</span>
                            </template>
                            <template #cell(nombre_factura)="{item}">
                                <span>{{ item.factura_name }}</span>
                            </template>
                            <template #cell(concepto)="{item}">
                                {{ item.concepto }}
                            </template>
                            <template #cell(subtotal)="{item}">
                                {{ item.subtotal }}
                            </template>
                            <template #cell(iva)="{item}">
                                <span>{{ formatCurrency(item.iva) }}</span>
                            </template>
                            <template #cell(fecha)="{item}">
                                <span>{{ formatDate(item.created_at) }}</span>
                            </template>
                            <template #cell(total)="{item}">
                                <span>{{ formatCurrency(item.total) }}</span>
                            </template>
                            <template #cell(complemento)="{item}">
                                <a target="_blank" v-if="item.payment_complement"
                                   :href="'/storage/especialistas/facturas/'+item.supplier_id+'/complementos/'+item.payment_complement.complement_name+'.pdf'"
                                   class="badge rounded-pill text-bg-green">
                                    <i class="fa-solid fa-file-invoice-dollar"></i>
                                </a>
                                <span v-else class="badge rounded-pill text-bg-gray">
                                    <i class="fa-solid fa-file-invoice-dollar"></i>
                                </span>
                            </template>
                            <template #cell(pago)="{item}">
                                <a v-if="item.tickets && item.tickets.length > 0" target="_blank"
                                   :href="'/storage/especialistas/tickets/'+item.supplier_id+'/'+item.tickets[0].ticketImg"
                                   class="badge rounded-pill text-bg-green">
                                    <i class="fa-solid fa-receipt"></i>
                                </a>
                                <span v-else class="badge rounded-pill text-bg-gray">
                                    <i class="fa-solid fa-receipt"></i>
                                </span>
                            </template>
                            <template #cell(acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="deleteOne(item.id)">
                                            Borrar
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col col-xl-3">
                            <b-pagination
                                :disabled="(specialist_id !== null)"
                                pills align="fill"
                                :hide-goto-end-buttons="true"
                                :limit="3"
                                v-model="pagination.current_page"
                                :total-rows="pagination.total"
                                :per-page="pagination.per_page"
                                aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
/*import {sinisterService} from "../../Services/Sinister.service";*/
import {invoicesService} from "../../Services/Invoices.service";
import {supplierspecialistService} from "../../Services/SupplierSpecialist.service";
import {rolesService} from "../../Services/Roles.service";
import {supplierdentistsService} from "../../Services/SupplierDentists.service";

export default {
    name: "payment-complement-admin",
    mixins: [myMixins],
    data() {
        return {
            selectMode: 'multi',
            isOpen: false,
            selectedAction: 'none',
            prov_role_id: 0,
            specialist_id: null,
            inst_id: 0,
            isBusy: false,
            filter: null,
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            fields: [
                {key: 'subir'},
                {key: 'id'},
                {key: 'proveedor'},
                {key: 'nombre_factura'},
                {key: 'concepto'},
                {key: 'subtotal'},
                {key: 'iva'},
                {key: 'total'},
                {key: 'fecha'},
                {key: 'complemento'},
                {key: 'pago'},
                {key: 'acciones'},

            ],
            specialists: [],
            originalData: [],
            providers: [],
            list_providers: [],
            params: {
                limit: 10,
                page: 1,
                status: null
            },
            dataRegister: {},
            model_type_row: '',
            invoice_id_row: '',
            total_invoice_row: '',
            supplier_id_row: '',
            reg_id_row: '',
            savedSelectedRows: [],
            selectedRows: [],
        }
    },
    methods: {
        async selectProvider() {
            this.providers = await rolesService.getProvidersForSinester();
            //console.log('providers', this.providers);
        },
        async selectCompanyByRoleProvider($e) {
            let id = this.stateId($e);
            let columnName = this.columnMapping[Number(id)];

            if (columnName) {
                let providers = await this.getProvidersByRole(id);
                // Procesa el nombre de la columna según sea necesario
                this.list_providers = this.processColumnNames(providers, columnName);
            }
        },
        processColumnNames(providers, columnName) {
            return providers.map(provider => ({
                id: provider.id,
                genericName: provider[columnName],
            }));
        },
        async getProvidersByRole(id) {
            switch (Number(id)) {
                /* case 3:
                     return supplierambulancesService.getMany({});*/
                case 4:
                    return supplierspecialistService.getMany({});
                /* case 7:
                     return supplierinstitutionsService.getMany({});*/
                /* case 10:
                     return supplierlaboratoriesService.getMany({});*/
                case 11:
                    return supplierdentistsService.getMany({});
                /*case 12:
                    return supplierradiologyService.getMany({});*/
                /*case 13:
                    return supplieropticiansService.getMany({});*/
                default:
                    return [];
            }
        },
        async deleteOne(id) {
            let resp = await invoicesService.deleteOne(id);
            this.getAlert(resp.process, true);
        },
        async filterStatusSinister() {
            // Crear una copia de this.originalData
            let dataCopy = [...this.originalData];

            switch (this.params.status) {
                case 0:
                    dataCopy = dataCopy.filter((item) => item.relbill !== null && item.paid_at === 0);

                    break;
                case 1:
                    dataCopy = dataCopy.filter((item) => item.paid_at === 1);
                    break;
                case 2:
                    dataCopy = dataCopy.filter((item) => item.relbill === null && item.paid_at === 0);
                    break;
                default:
                    this.params.status = null;
                    break;
            }

            if (dataCopy.length === 0) {
                this.getAlert('no_data');
            } else {
                this.pagination.data = dataCopy;
            }
            // Actualizar this.pagination.data con los datos filtrados

        },
        async filterBySpecialist() {

            if (this.specialist_id === null) {
                this.params = {
                    limit: 10,
                    page: 1,
                    status: null
                }
                //console.log('entro al if para volver a cargar todos los registros y activar la paginacion');
                await this.index();
            } else {
                this.isBusy = true;
                this.params.limit = 0;
                this.params.where = [
                    {
                        field: 'model_type',
                        operator: '=',
                        value: 'App\\Models\\' + this.roleModels[this.prov_role_id],
                    }, {
                        field: 'supplier_id',
                        operator: '=',
                        value: this.specialist_id,
                    }
                ];
                if (this.params.status !== null) {
                    this.params.where.push({
                        field: 'paid_at',
                        operator: '=',
                        value: this.params.status,
                    });
                }
                this.pagination.data = await invoicesService.getMany(this.params);
                if (this.pagination.data.length === 0) {
                    this.getAlert('no_data');
                } else {
                    this.originalData = [...this.pagination.data];
                }
                this.isBusy = false;
            }


        },
        async index() {
            //console.log('entro al index');
            this.isBusy = true;
            this.specialists = await supplierspecialistService.getMany();
            this.pagination = await invoicesService.getMany(this.params);
            this.isBusy = false;
        },
        changeLimit() {
            this.index();
        },
        clickRow(index, item, rowSelected) {
            //console.log('index', index, 'item', item, 'rowSelected', rowSelected, 'type', type);
            if (rowSelected) {
                this.$refs.selectableTable.unselectRow(index);
                this.total_invoice_row -= item.total;
            } else if (item.paid_at !== 1) {
                this.theRowSelected = true;
                this.$refs.selectableTable.selectRow(index);
                this.total_invoice_row += +item.total;
                if (this.savedSelectedRows.length === 0) {
                    console.log(item)
                    this.model_type_row = item.model_type.replace('App\\Models\\', '');
                    this.invoice_id_row = item.id;
                    this.total_invoice_row = +item.total;
                    this.supplier_id_row = item.supplier_id;
                    this.reg_id_row = item.reg_id;

                    //console.log('model_type_row', this.model_type_row);
                }
            }
        },
        loadTicket() {
            this.openModalsProviders('payment_invoice')
        },
        loadComplement() {
            this.openModalsProviders('complement_invoice')
        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        onRowSelected(items) {
            //this.kind_bill = 1;
            //console.log('onRowSelected', items);
            //FILTRO LOS REGISTROS QUE NO TIENEN TICKET Y QUE NO TIENE COMPLEMENTO DE PAGO
            this.selectedRows = items.filter((item) => item.ticket_admin !== 1 || item.payment_complement !== 1);
            //console.log('selectedRows', this.selectedRows);
            //GUARDO EL ID DEL SINIESTRO Y EL ID DEL PROVEEDOR
            //SE LE QUITO EL item.supplier_id por que ya se esta mandando el tado por prop
            this.savedSelectedRows = this.selectedRows.map((item) => [item.id]);
            //console.log('savedSelectedRows', this.savedSelectedRows);
            this.total_invoice_row = this.selectedRows.reduce((total, item) => total + +item.total, 0);
        },
        toggleOpen() {
            this.isOpen = !this.isOpen;
        },
        updateAction($e) {
            this.selectedAction = this.stateId($e);
            //console.log('selectedAction', this.selectedAction);

            switch (this.selectedAction) {
                case '1':
                    this.loadTicket();
                    break;
                case '2':
                    this.loadComplement()
                    break;
            }

        }
    },
    async mounted() {
        await this.selectProvider();

        await this.index();
    },
    computed: {
        computedModelTypeRow() {
            return this.model_type_row;
        },
    }
}
</script>

